<template>
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-card class="sa-card sa-card-border" header="Informazioni Personali" header-tag="header" footer-tag="footer">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Eta:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.eta }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.eta" :readonly="isReadOnly" type="number" />
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Scolarita:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.scolarita }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.scolarita" :readonly="isReadOnly" />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Occupazione:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.occupazione }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.occupazione" :readonly="isReadOnly" />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Altro:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.informazioniPersonaliAltro }}</span>
                        <b-form-textarea v-else v-model="jsonDataSchedaPsicologica.informazioniPersonaliAltro" :readonly="isReadOnly" max-rows="10" rows="4" />
                    </b-col>
                </b-row>
            </b-card>

            <b-card class="sa-card sa-card-border" header="Informazioni cliniche" header-tag="header" footer-tag="footer">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Diagnosi principale:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.diagnosiPrincipale }}</span>
                        <b-form-textarea v-else v-model="jsonDataSchedaPsicologica.diagnosiPrincipale" :readonly="isReadOnly" max-rows="10" rows="4" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Comorbidita:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.comorbidita }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.comorbidita" :readonly="isReadOnly" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Deficit sensoriali:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.deficitSensoriali }}</span>
                        <b-form-select v-else v-model="jsonDataSchedaPsicologica.deficitSensoriali" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text" />
                    </b-col>
                    <b-col v-if="jsonDataSchedaPsicologica.deficitSensoriali === 'SI'" cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                        <label class="sa-label-data">Specificare i deficit sensoriali:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.deficitSensorialiAltro }}</span>
                        <b-form-textarea v-else v-model="jsonDataSchedaPsicologica.deficitSensorialiAltro" rows="3" max-rows="6" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Deficit motori:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.deficitMotori }}</span>
                        <b-form-select v-else v-model="jsonDataSchedaPsicologica.deficitMotori" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text" />
                    </b-col>
                    <b-col v-if="jsonDataSchedaPsicologica.deficitMotori === 'SI'" cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                        <label class="sa-label-data">Specificare i deficit motori:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.deficitMotoriAltro }}</span>
                        <b-form-textarea v-else v-model="jsonDataSchedaPsicologica.deficitMotoriAltro" rows="3" max-rows="6" />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.informazioniClinicheNote }}</span>
                        <b-form-textarea v-else v-model="jsonDataSchedaPsicologica.informazioniClinicheNote" :readonly="isReadOnly" max-rows="10" rows="4" />
                    </b-col>
                </b-row>
            </b-card>

            <b-card class="sa-card sa-card-border" header="Contesto socio-relazionale" header-tag="header" footer-tag="footer">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Caregiver:</label>
                        <b-row>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-for="caregiver in caregiverOptions" :key="'caregiver-' + caregiver.id" class="sa-switch-select-element">
                                <b-form-checkbox switch :disabled="isReadOnly" v-model="selectedCaregiver" :value="caregiver.voce" @change="onChangeCheckbox">
                                    <span style="font-weight: normal">{{ caregiver.voce }}</span>
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Presenza di una rete familiare/sociale supportiva:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.presenzaReteFamiliareSociale }}</span>
                        <b-form-select v-else v-model="jsonDataSchedaPsicologica.presenzaReteFamiliareSociale" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text" />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Problemi familiari/sociali segnalati all'ingresso:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.problemiFamiliariIngresso }}</span>
                        <b-form-select v-else v-model="jsonDataSchedaPsicologica.problemiFamiliariIngresso" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text" />
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.contestoSocioRelazionaleNote }}</span>
                        <b-form-textarea v-else v-model="jsonDataSchedaPsicologica.contestoSocioRelazionaleNote" :readonly="isReadOnly" max-rows="10" rows="4" />
                    </b-col>
                </b-row>
            </b-card>

            <b-card class="sa-card sa-card-border" header="Valutazione globale e funzionale all'ingresso" header-tag="header" footer-tag="footer">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Vigilanza e collaborazione:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.vigilanzaCollaborazione }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.vigilanzaCollaborazione" :readonly="isReadOnly" />
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Orientamento:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.orientamento }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.orientamento" :readonly="isReadOnly" />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Funzionamento cognitivo:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.funzionamentoCognitivo }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.funzionamentoCognitivo" :readonly="isReadOnly" />
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Linguaggio e comunicazione:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.linguaggioComunicazione }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.linguaggioComunicazione" :readonly="isReadOnly" />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Tono dell'umore:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.tonoUmore }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.tonoUmore" :readonly="isReadOnly" />
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Comportamento e attivita' psicomotorie:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.comportamentoAtivitaPsicomotorie }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.comportamentoAtivitaPsicomotorie" :readonly="isReadOnly" />
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Autonomia:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.autonomia }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.autonomia" :readonly="isReadOnly" />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.valutazioneGlobaleNote }}</span>
                        <b-form-textarea v-else v-model="jsonDataSchedaPsicologica.valutazioneGlobaleNote" :readonly="isReadOnly" max-rows="10" rows="5" />
                    </b-col>
                </b-row>
            </b-card>

            <b-card class="sa-card sa-card-border" header="Presa in carico psicologica" header-tag="header" footer-tag="footer">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Intervento psicologico:</label>

                        <b-row>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-for="interventoPsicologico in interventoPsicologicoOptions" :key="'interventoPsicologico-' + interventoPsicologico.id" class="sa-switch-select-element">
                                <b-form-checkbox switch :disabled="isReadOnly" v-model="selectedInterventoPsicologico" :value="interventoPsicologico.voce" @change="onChangeCheckbox">
                                    <span style="font-weight: normal">{{ interventoPsicologico.voce }}</span>
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Tipologia di intervento:</label>
                        <b-row>
                            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" v-for="tipologia in tipologiaInterventoOptions" :key="'tipologia-' + tipologia.id" class="sa-switch-select-element">
                                <b-form-checkbox switch :disabled="isReadOnly" v-model="selectedTipologiaIntervento" :value="tipologia.voce" @change="onChangeCheckbox">
                                    <span style="font-weight: normal">{{ tipologia.voce }}</span>
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-col></b-row
                >

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.presaCaricoPsicologicaNote }}</span>
                        <b-form-textarea v-else v-model="jsonDataSchedaPsicologica.presaCaricoPsicologicaNote" :readonly="isReadOnly" max-rows="10" rows="5" />
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Altri rilievi:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.altriRilievi }}</span>
                        <b-form-textarea v-else v-model="jsonDataSchedaPsicologica.altriRilievi" :readonly="isReadOnly" max-rows="10" rows="5" />
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],

    props: {
        idRisorsa: {
            type: String,
            default() {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default() {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            pathResourceSchedaPsicologica: "/rsaschedavalutazioneschedapsicologicarsa",
            pathResourceDizionario: "/rsadizionario",

            caregiverOptions: [],
            tipologiaInterventoOptions: [],
            interventoPsicologicoOptions: [],

            selectedCaregiver: [],
            selectedTipologiaIntervento: [],
            selectedInterventoPsicologico: [],

            jsonDataSchedaPsicologica: this.getDefaultSchedaPsicologica(),

            sinoOptions: [
                { value: null, text: "Seleziona valore", disabled: true },
                { value: "SI", text: "SI" },
                { value: "NO", text: "NO" },
            ],
        };
    },

    mounted() {
        let me = this;
        let routeIdAccettazione = me.$route?.query?.idAccettazione ? me.$route.query.idAccettazione : me.$route?.params?.id;

        me.jsonDataSchedaPsicologica = me.getDefaultSchedaPsicologica(this.idAccettazione || routeIdAccettazione);
        me.loadDizionarioData();

        if (me.idRisorsa) {
            me.visualizzaSchedaPsicologica();
        }
    },

    watch: {
        jsonDataSchedaPsicologica: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
        "jsonDataSchedaPsicologica.deficitSensoriali"(newValue) {
            if (newValue === "NO") {
                this.jsonDataSchedaPsicologica.deficitSensorialiAltro = null;
            }
        },

        "jsonDataSchedaPsicologica.deficitMotori"(newValue) {
            if (newValue === "NO") {
                this.jsonDataSchedaPsicologica.deficitMotoriAltro = null;
            }
        },
    },

    methods: {
        getDefaultSchedaPsicologica(idAccettazione = null) {
            return {
                id: null,
                idAccettazione: idAccettazione,
                scolarita: null,
                occupazione: null,
                informazioniPersonaliAltro: null,
                diagnosiPrincipale: null,
                comorbidita: null,
                informazioniClinicheNote: null,
                presenzaReteFamiliareSociale: null,
                problemiFamiliariIngresso: null,
                contestoSocioRelazionaleNote: null,
                vigilanzaCollaborazione: null,
                orientamento: null,
                funzionamentoCognitivo: null,
                linguaggioComunicazione: null,
                tonoUmore: null,
                comportamentoAtivitaPsicomotorie: null,
                valutazioneGlobaleNote: null,
                presaCaricoPsicologicaNote: null,
                altriRilievi: null,
                autonomia: null,
                eta: 0,
                listaSchedaPsicologicaDettagli: [],
                deficitSensorialiAltro: null,
                deficitMotoriAltro: null,
                deficitSensoriali: null,
                deficitMotori: null,
            };
        },

        formatDettaglioValue(tipo) {
            if (!this.jsonDataSchedaPsicologica.listaSchedaPsicologicaDettagli) {
                return "";
            }

            return this.jsonDataSchedaPsicologica.listaSchedaPsicologicaDettagli
                .filter((item) => item.tipo === tipo)
                .map((item) => item.voce)
                .join(", ");
        },

        onChangeCheckbox() {
            this.setDettaglioCheckbox();
        },

        setDettaglioCheckbox() {
            let listaSchedaPsicologicaDettagli = [];

            this.selectedCaregiver.forEach((voce) => {
                listaSchedaPsicologicaDettagli.push({
                    id: null,
                    idSchedaPsicologica: this.jsonDataSchedaPsicologica.id,
                    tipo: "CAREGIVER",
                    voce: voce,
                });
            });

            this.selectedInterventoPsicologico.forEach((voce) => {
                listaSchedaPsicologicaDettagli.push({
                    id: null,
                    idSchedaPsicologica: this.jsonDataSchedaPsicologica.id,
                    tipo: "INTERVENTO PSICOLOGICO",
                    voce: voce,
                });
            });

            this.selectedTipologiaIntervento.forEach((voce) => {
                listaSchedaPsicologicaDettagli.push({
                    id: null,
                    idSchedaPsicologica: this.jsonDataSchedaPsicologica.id,
                    tipo: "TIPOLOGIAINTERVENTO",
                    voce: voce,
                });
            });

            this.jsonDataSchedaPsicologica.listaSchedaPsicologicaDettagli = listaSchedaPsicologicaDettagli;
        },

        loadDizionarioData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceDizionario, null, me.loadDizionarioDataSuccess, me.loadDizionarioDataError);
        },

        loadDizionarioDataSuccess(response) {
            let me = this;
            if (response.data.data.list) {
                me.caregiverOptions = response.data.data.list.filter((item) => item.tipo === "CAREGIVER");
                me.tipologiaInterventoOptions = response.data.data.list.filter((item) => item.tipo === "TIPOLOGIAINTERVENTO");
                me.interventoPsicologicoOptions = response.data.data.list.filter((item) => item.tipo === "INTERVENTO PSICOLOGICO");
            }
        },

        loadDizionarioDataError(error) {
            console.error("Errore nel caricamento dizionario", error);
        },

        visualizzaSchedaPsicologica() {
            let me = this;
            me.selectedCaregiver = [];
            me.selectedTipologiaIntervento = [];
            me.selectedInterventoPsicologico = [];

            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaPsicologica + "/" + me.idRisorsa, null, me.loadDataSchedaPsicologicaSuccess, me.loadDataSchedaPsicologicaError);
        },

        loadDataSchedaPsicologicaSuccess(response) {
            let me = this;
            me.jsonDataSchedaPsicologica = {
                ...me.getDefaultSchedaPsicologica(me.idAccettazione),
                ...response.data.data,
            };
            me.selectedCaregiver = [];
            me.selectedInterventoPsicologico = [];
            me.selectedTipologiaIntervento = [];

            if (me.jsonDataSchedaPsicologica.listaSchedaPsicologicaDettagli) {
                me.jsonDataSchedaPsicologica.listaSchedaPsicologicaDettagli.forEach((dettaglio) => {
                    if (dettaglio.tipo === "CAREGIVER") {
                        me.selectedCaregiver.push(dettaglio.voce);
                    }

                    if (dettaglio.tipo === "TIPOLOGIAINTERVENTO") {
                        me.selectedTipologiaIntervento.push(dettaglio.voce);
                    }

                    if (dettaglio.tipo === "INTERVENTO PSICOLOGICO") {
                        me.selectedInterventoPsicologico.push(dettaglio.voce);
                    }
                });
            }

            me.$emit("afterLoadData", me.jsonDataSchedaPsicologica);
        },

        loadDataSchedaPsicologicaError(error) {
            this.$emit("afterLoadData", error);
            this.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        resetForm() {
            this.jsonDataSchedaPsicologica = this.getDefaultSchedaPsicologica(this.idAccettazione);
            this.selectedCaregiver = [];
            this.selectedTipologiaIntervento = [];
            this.selectedInterventoPsicologico = [];
        },
    },
};
</script>
